import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { inr } from "@/theme";
import { useAdminTheme } from "@/admin/AdminTheme";
import { ACard, Badge, STATUS_TONE, AdminPageTitle } from "@/admin/ui";
import { Spinner } from "@/components/common";

const FILTERS = ["all", "created", "paid", "shipped", "delivered", "cancelled"];

export default function AdminOrders() {
  const { c } = useAdminTheme();
  const [orders, setOrders] = useState(null);
  const [filter, setFilter] = useState("all");
  const navigate = useNavigate();

  useEffect(() => { api("/admin/orders").then(setOrders).catch(() => setOrders([])); }, []);
  if (!orders) return <Spinner full />;

  const shown = filter === "all" ? orders : orders.filter((o) => o.status === filter);

  return (
    <div className="fade-up">
      <AdminPageTitle title="Orders" subtitle={`${orders.length} total`} />
      <div style={{ display: "flex", gap: 8, marginBottom: 18, flexWrap: "wrap" }}>
        {FILTERS.map((f) => (
          <button key={f} data-testid={`order-filter-${f}`} onClick={() => setFilter(f)}
            style={{ padding: "7px 14px", borderRadius: 999, border: `1px solid ${c.border}`, cursor: "pointer", textTransform: "capitalize",
              background: filter === f ? c.primary : c.surface, color: filter === f ? c.onPrimary : c.onSurfaceSecondary, fontWeight: 600, fontSize: 13 }}>
            {f}
          </button>
        ))}
      </div>
      <ACard style={{ padding: 0, overflow: "hidden" }}>
        {shown.length === 0 ? <p style={{ padding: 24, color: c.mutedText }}>No orders in this view.</p> : shown.map((o) => (
          <div key={o.id} data-testid={`admin-order-${o.id}`} onClick={() => navigate(`/admin/order/${o.id}`)}
            style={{ display: "flex", alignItems: "center", gap: 14, padding: "14px 18px", borderBottom: `1px solid ${c.divider}`, cursor: "pointer" }}>
            {o.items?.[0]?.image && <img src={o.items[0].image} alt="" style={{ width: 44, height: 44, borderRadius: 8, objectFit: "cover" }} />}
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 700, fontSize: 13.5 }}>#{o.id.slice(0, 8)} · {o.shipping_name}</div>
              <div className="clamp-1" style={{ fontSize: 12.5, color: c.mutedText }}>{o.items?.map((i) => `${i.name} ×${i.quantity}`).join(", ")}</div>
              <div style={{ fontSize: 11.5, color: c.mutedText, marginTop: 2 }}>{new Date(o.created_at).toLocaleString()}</div>
            </div>
            <div style={{ textAlign: "right" }}>
              <div style={{ fontWeight: 700, marginBottom: 6 }}>{inr(o.amount)}</div>
              <Badge tone={STATUS_TONE[o.status]}>{o.status}</Badge>
            </div>
          </div>
        ))}
      </ACard>
    </div>
  );
}
